<template>
  <div class="event-item">
    <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteEventItem(item.id)"/>
    <div class="columns">
      <div class="is-one-quarter column">
        <el-time-picker
          format="HH:mm"
          @change="timeChanged"
          v-model="time"
          :picker-options="{
            start: '00:00',
            step: '00:10',
            end: '23:59'
          }"
          placeholder="00:00">
        </el-time-picker>
      </div>
      <div class="is-half column">
        <b-field>
            <b-input placeholder="Заголовок" required v-model="item.title" @change="handleUpdate"></b-input>
        </b-field>
        <div v-if="!item.speakers.length">
          <span class="link" @click="handleAddSpeaker">Добавить спикера</span>
          <br>
          <span class="link add-subtitle" @click="handleAddSubtitle">Добавить подзаголовок</span>
        </div>
      </div>
    </div>
    <div class="speakers" v-if="item.speakers">
      <EventItemSpeaker v-for="(speaker, ind) in item.speakers" :index="ind" :speaker="speaker" :key="speaker.id" />
    </div>
    <div class="column is-offset-one-quarter">
      <div class="addition-buttons" v-if="item.speakers.length">
        <span class="link" @click="handleAddSpeaker">Добавить спикера</span>
        <br>
        <span class="link add-subtitle" @click="handleAddSubtitle">Добавить подзаголовок</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import EventItemSpeaker from './EventItemSpeaker'
import uuidv4 from 'uuid/v4'

export default {
  name: 'EventItem',
  data () {
    return {
      time: ''
    }
  },
  props: {
    item: {
      required: true
    }
  },
  created () {
    const d = new Date()
    if (this.item.time) {
      const time = this.item.time.split(':')
      d.setHours(time[0])
      d.setMinutes(time[1])
      this.time = d
    }
  },
  methods: {
    ...mapActions(['updateEventItem', 'addSpeaker',
      'deleteSpeaker', 'loadSpeakerPhoto',
      'deleteSpeakerPhoto', 'deleteEventItem',
      'addSubtitle']),
    timeChanged (value) {
      this.item.time = value || ''
    },
    handleAddSpeaker () {
      this.addSpeaker({ type: 'speaker', id: uuidv4(), event_item_id: this.item.id })
    },
    handleAddSubtitle () {
      this.addSubtitle({ type: 'subtitle', id: uuidv4(), event_item_id: this.item.id })
    },
    handleUpdate () {
      this.updateEventItem(this.item)
    }
  },
  components: { EventItemSpeaker }
}
</script>
<style scoped>
.delete-icon {
  top: -8px;
  right: -8px;
  z-index: 0;
}
.event-item {
  position: relative;
  background: #eeeeee;
  padding: 20px;
  margin: 10px 0;
}
.addition-buttons {
  margin: 0 0 0 50px;
}
.add-subtitle {
  margin: 20px 0 0;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// EventItem.vue?6a991ccf